import React from "react";
import { FormAlphaNumericError, FormMaxError, FormMinError, FormRequiredError, FormNumberError, FormSelectError, FormDateMinError, FormMinimumConditionalError, FormMaximumConditionalError, FormInvalidError, FormNumberMaxError, FormNumberMinError, FormRequiredConditionalError } from "../../errors";

class EventFormError extends React.Component {

    render() {
        let error = this.props.error.split('|');
        if (this.props.error.slice(-6) === "number") {
            return <FormNumberError field_name={error[0]} />
        } else if (error[1] === 'min_date') {
            return <FormDateMinError field_name={error[0]} />
        } else if (this.props.error.slice(-10) === 'number_max') {
            return <FormNumberMaxError field_name={error[0]} max={error[1]} />
        } else if (this.props.error.slice(-10) === 'number_min') {
            return <FormNumberMinError field_name={error[0]} min={error[1]} />
        } else if (this.props.error.slice(-3) === "max") {
            return <FormMaxError field_name={error[0]} max={error[1]} />
        } else if (this.props.error.slice(-3) === "min") {
            return <FormMinError field_name={error[0]} min={error[1]} />
        } else if (this.props.error.slice(-5) === "match") {
            return <FormAlphaNumericError field_name={error[0]} />
        } else if (this.props.error.slice(-7) === "invalid") {
            return <FormInvalidError field_name={error[0]} />
        } else if (this.props.error.slice(-6) === 'select') {
            return <FormSelectError field_name={error[0]} />
        } else if (this.props.error.slice(-15) === 'min_conditional') {
            return <FormMinimumConditionalError field1={error[0]} field2={error[1]} />
        } else if (this.props.error.slice(-15) === 'max_conditional') {
            return <FormMaximumConditionalError field1={error[0]} field2={error[1]} />
        } else if (this.props.error?.indexOf('required.conditional') > -1) {
            return <FormRequiredConditionalError field1={error[0]} field2={error[1]} />;
        } else {
            return <FormRequiredError field_name={this.props.error} />
        }
    }
}

export default EventFormError;